import { View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'

const Coonline = ({ navigation, route }: any) => {
  const {
    userId,
    mode,
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
    values,
    description
  } = route.params

  const personalstore = usePersonalStore()
  const intializestore = useInitializeStore()
  const { loading, postcoonline } = useFormsStore()
  const handlesubmit = async (signatureDataURL: string) => {
    const data = {
      completeOnline: true,
      essUserKey: intializestore.initializeData.userkey,
      entityId: personalstore.personalData?.entityId,
      essUserOnBoardingFormKey: essUserOnBoardingFormKey,
      essObKey: essUserOnBoardingKey,
      sign: signatureDataURL,
      AnnualWithholdingAllowance: Number(values?.annualWithholdingAllowance) || null,
      AdditionalWperPayPeriod: Number(values?.additionalWithholding) || null,
      filingStatus: description

    }
    const response = await postcoonline(data)
    if (response?.success) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }

  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navLabel="Forms"
            navScreen="OnboardingForms"
            title={'CO Withholding Taxation'}
          />
        </View>
      </View>
      <SignatureFormView
        essUserOnBoardingFormKey={essUserOnBoardingFormKey}
        essUserOnBoardingKey={essUserOnBoardingKey}
        isSubmitting={loading}
        onPrevious={() =>
          navigation.navigate('CoinformationForm', {
            essUserOnBoardingFormKey,
            essUserOnBoardingKey,
            values,
            mode: "online",

          })
        }
        onSubmit={handlesubmit}
        stateValue='CO'
      />

    </>
  )
}
export default Coonline
